import {
  GET_LOYALTY_SUCCESS,
  GET_LOYALTY_FAILURE,
  CREATE_GIVEX_LOYALTY_REQUEST,
  CREATE_GIVEX_LOYALTY_SUCCESS,
  CREATE_GIVEX_LOYALTY_FAILURE,
  UPDATE_LOYALTY_REGISTRATION_MODAL_STATUS,
  DISPLAY_TRANSFER_BALANCE_MODAL,
} from './loyaltyTypes';
import api from '../../api';
import { getPaymentMethods } from '../PaymentMethods/paymentMethodsActions';
import appConfig from '../../../app-config';
import { createAlert } from '../Alert/alertActions';

export function getLoyalty() {
  return function(dispatch, getState) {
    // dispatch({type: GET_LOYALTY_REQUEST});
    const { isAuthenticated } = getState().authReducer;
    if (!isAuthenticated) {
      return;
    }
    return api.get(`/customer/loyalty`).then(
      (response) => {
        dispatch({ type: GET_LOYALTY_SUCCESS, response: response.data });
      },
      (error) => {
        dispatch({ type: GET_LOYALTY_FAILURE, error });
      }
    );
  };
}

export function createLoyalty(
  loyalty_number = null,
  pin = null,
  setRegistrationStep = null
) {
  const formBody = loyalty_number
    ? { loyalty_number, create: false, pin }
    : { create: true, loyalty_number: '', pin: '' };
  return function(dispatch, getState) {
    const { isAuthenticated } = getState().authReducer;
    if (!isAuthenticated) {
      return;
    }
    dispatch({ type: CREATE_GIVEX_LOYALTY_REQUEST });
    dispatch({
      type: 'REQUESTING_NEW_DIGITAL_CARD',
      requestingNewDigitalCard: true,
    });
    return api.post(`/customer/loyalty`, formBody).then(
      (response) => {
        dispatch({
          type: CREATE_GIVEX_LOYALTY_SUCCESS,
          isCreated: loyalty_number ? false : true,
        });
        dispatch(getLoyalty());
        dispatch(getPaymentMethods());
        dispatch({
          type: 'REQUESTING_NEW_DIGITAL_CARD',
          requestingNewDigitalCard: false,
        });
        dispatch(setLoyaltyRegistrationModalOpen(false));
      },
      (error) => {
        dispatch({ type: CREATE_GIVEX_LOYALTY_FAILURE });
        createAlert({
          type: 'error',
          message: 'Something went wrong. Please try again.',
        });
      }
    );
  };
}

export function setLoginToken() {
  return function(dispatch) {
    dispatch({
      type: 'LOGIN_SUCCESS',
      token: localStorage.getItem(`${appConfig.appSource}_token`),
    });
  };
}

export function setLoyaltyRegistrationModalOpen(isOpen) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_LOYALTY_REGISTRATION_MODAL_STATUS,
      isOpen,
    });
  };
}

export function displayTransferBalanceModal(isTransferBalanceModalVisible) {
  return {
    type: DISPLAY_TRANSFER_BALANCE_MODAL,
    isTransferBalanceModalVisible,
  };
}
